// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { arrowExpanderDown16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-arrow-expander-down': IconArrowExpanderDown;
    }
}

/**
 * The icon component for the 'arrowExpanderDown' icon
 */
export class IconArrowExpanderDown extends Icon {
    public constructor() {
        super(arrowExpanderDown16X16);
    }
}

registerIcon('icon-arrow-expander-down', IconArrowExpanderDown);
export const iconArrowExpanderDownTag = 'nimble-icon-arrow-expander-down';
